// extracted by mini-css-extract-plugin
export default {"mediaWrapper":"Media_mediaWrapper__ZOSMh","itemIcon":"Media_itemIcon__gBqfk","mediaIcons":"Media_mediaIcons__EPgJV"};